import comp from "./AIJustification.js";
export default comp;
